import React, { useState, useEffect } from 'react'
import { demux } from '../boolean.js'
export const Demux = () => {
    const [positive, setPositive] = useState(0)
    const [negative, setNegative] = useState(0)
    const [result, setResult] = useState(0)
    const togglePositive = () => { 
        setPositive(positive ? 0 : 1)
    }

    const toggleNegative = () => { 
        setNegative(negative ? 0 : 1)
    }

    useEffect(() => { 
        setResult(demux(positive, negative))
    }, [positive, negative, setResult])

    return <div>
        <h2>DEMUX</h2>
        <input onChange={togglePositive} type="checkbox" value="positive" name="battery" /> A
        <input onChange={toggleNegative} type="checkbox" value="negative" name="battery" /> B
        <div>
           result: {JSON.stringify(result)}
        </div>
    </div>
}
